import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import M from 'materialize-css/dist/js/materialize';
import { withRouter, useParams } from 'react-router-dom';
import ConfirmModal from '../../../../../components/UI/ConfirmModal';
import BackButton from '../../../../../components/UI/BackButton';
import { translate } from '../../../../../utils/util';
import PickingService from '../../../../../services/PickingService';
import LinePickingService from '../../../../../services/LinePickingService';

const OrderNotFound = (props) => {
    const { orderId } = useParams();
    const [order, setOrder] = useState();
    const getJustificationDescription = (value) => props.justifications?.items?.find(o => o.justificationId === value)?.description;

    const openModal = () => {
        const modal = M.Modal.init(document.getElementById('confirmNt'));
        modal.open();
    }

    const finished = () => {
        props.updateStatusNt(order.orderId, () => {
            props.history.go(-1);
        })
    };

    const onCancel = () => {
        props.history.go(-1);
    }

    useEffect(() => {
        if (orderId) {
            props.getOrder(orderId, (response) => {
                setOrder(response);
            });
        } else if (props.order && props.order.items) {
            setOrder(props.order);
        }
        // eslint-disable-next-line
    }, []);

    return (
        <div>
            <BackButton {...props} />
            {
                order && (
                    <div className="container">
                        <div className="card">
                            <div className="card-content" style={{ padding: '10px' }}>
                                <div className="row" style={{ marginBottom: '0' }}>
                                    <div className="subtitle col s12" style={{ padding: '0px' }}>
                                        <span className="field f-1r truncate">{translate("line-picking:linepicking.order-details")}</span>
                                    </div>
                                    <div className="input-field no-padding col s4">
                                        <span className="field f-1p45r truncate">{order?.items[0].auxCode}</span>
                                        <label className="active" htmlFor="cim">{translate('line-picking:linepicking.CIM')}</label>
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <span className="field f-1p45r">{order?.items[0].partnumber}</span>
                                        <label className="active" htmlFor="partnumber">{translate('expedition:picking.partnumber')}</label>
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <span className="field f-1r truncate">{order?.items[0].description}</span>
                                        <label className="active">{translate('expedition:picking.description')}</label>
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <span className="field f-1p45r truncate" style={{ fontWeight: 'bold' }}>{order?.items[0].location}</span>
                                        <label className="active">{translate('line-picking:linepicking.location')}</label>
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <span className="field f-1p45r truncate" style={{ fontWeight: 'bold' }}>{order?.items[0].mdrType}</span>
                                        <label className="active">{translate('expedition:picking.mdrType')}</label>
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <span className="field f-1r truncate">{order?.items[0].quantity}</span>
                                        <label className="active">{translate('line-picking:linepicking.amount')}</label>
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <span className="field f-1r truncate">{order?.orderCode}</span>
                                        <label className="active">{translate('expedition:picking.orderCode')} MES</label>
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <span className="field f-1r truncate">{order?.items[0].partial ? translate('line-picking:linepicking.yes') : translate('line-picking:linepicking.no')}</span>
                                        <label className="active">{translate('line-picking:linepicking.partial')}</label>
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <span className="field f-1r truncate">{getJustificationDescription(order?.items[0].justificationId)}</span>
                                        <label className="active" htmlFor="nivel">{translate('line-picking:linepicking.justification')} </label>
                                    </div>
                                </div>
                                <div className="card-action row center" style={{ padding: '1rem 0', marginBottom: '0' }}>
                                    <button
                                        type="button"
                                        onClick={openModal}
                                        className="col s12
                                        btn
                                        btn-principal
                                        waves-effect
                                        waves-light"
                                    >
                                        {translate('line-picking:linepicking.confirmNt')}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <ConfirmModal
                            id="confirmNt"
                            data={{ title: translate('validations:attention'), message: `${translate('line-picking:messages.confirm-finished-Nt')} ${order?.items[0].partnumber}` }}
                            onConfirm={finished}
                            onCancel={onCancel}
                            btnCancel={translate('general:cancel')}
                            btnConfirm={translate('general:confirm')}
                        />
                    </div>
                )
            }
        </div>
    );
}
const mapStateToProps = (state) => {
    return {
        order: state.linePickingReducer.order,
        justifications: state.justificationReducer.justifications,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getOrder: (orderId, callback) => {
            dispatch(PickingService.getOrder(orderId, callback));
        },
        updateStatusNt: (orderId, callback) => {
            dispatch(LinePickingService.finishedmaterialNotFound(orderId, callback));
        },
    }
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OrderNotFound)));